export const environment = {
  production: false,
  apiUrl: 'https://api.skipulag.site',
  // apiUrl: 'http://34.133.52.151:3000',
};
